






























import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryAllShopNameList,QueryOrderInfoList,QuerySettlementOrderCounts, ConfirmOrder, DeliveryOrder, RefusedOrder,BatchConfirmOrder,BatchDeliveryOrder, ConfirmRefund, CancelRefund,ExportSettlementOrder } from '@/api'
import { DateFormat,DateFormat2 } from '@/utils/date/DateUtil'
import { PriceFormat, SettlementFormat,OrderStatusFormat,PayChannelFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import OrderDescDialog from './OrderDescDialog.vue'
import { Message, MessageBox } from 'element-ui'
import ExpressDialog from './componetns/ExpressDialog.vue'
import ShippedDialog from './componetns/ShippedDialog.vue'
import UpdateShippedDialog from './componetns/UpdateShippedDialog.vue'
import {getUser} from '@/store/userStore'
import UserWealthRecordDialog from '@/views/user/components/UserWealthRecordDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    OrderDescDialog,
    ExpressDialog,
    ShippedDialog,
    UserWealthRecordDialog,
    UpdateShippedDialog
  },
})
export default class OrderList extends Vue {
  private queryParam: any = {
    // orderType: 0,
    startRow: 1,
    limit: 10,
    settlementTimeDaterange:[],
    createTimeDaterange:[],
    receiveTimeDaterange:[],
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private selectData: Array<any> = []

  private user = getUser()

  private activeMenu: any = 'ALL'
  private orderCounts = {}
  private shopIdOption: Array<any> = []
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption,show:()=>{return this.user.user.role != 2}}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '订单类型', param: 'orderType', type: 'select', selectData: constant.OrderType },
    this.shopIdQueryParam,
    { title: '订单状态', param: 'orderStatus', type: 'select', selectData: constant.OrderStatus },
    { title: '订单编号', param: 'orderCode' },
    { title: '结算时间', param: 'settlementTimeDaterange', type: 'daterange' },
    { title: '确认收货时间', param: 'receiveTimeDaterange', type: 'daterange' },
    { title: '创建时间', param: 'createTimeDaterange', type: 'daterange' },
    { title: '支付方式', param: 'payChannel',type: 'select', selectData: constant.PayChannel  },
    { title: '支付渠道', param: 'payChannelMerchant',type: 'select', selectData: constant.PayChannelMerchant2 },
    { title: '支付单号', param: 'payOrderNo'},
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '批量确认', type: 'primary', click: this.batchConfirmOrder, disable: this.batchDisable },
    // { title: '批量发货', type: 'primary', click: this.batchDeliveryOrder, disable: this.batchDisable },
    { title: '批量导出', type: 'primary', click: this.exportOrderHandle},
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '选择',  type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    { title: '店铺', param: 'shopId',width:200 ,formatter: this.shopNameForam, overflow: true,hide:this.user.user.role == 2},
    { title: '订单编号', param: 'orderCode', overflow: true,width:200 },
    { title: '用户ID', param: 'userId',width:100 },
    { title: '客户手机号', param: 'mobilePhone',width:120 },
    { title: '订单金额', param: 'orderAmount', formatter: PriceFormat },
    { title: '支付金额', param: 'payAmount', formatter: PriceFormat },
    { title: '支付方式', param: 'payChannel', formatter: PayChannelFormat },
    { title: '支付渠道', param: 'payChannelMerchant'},
    { title: '订单PV', param: 'orgPv', formatter: PriceFormat },
    { title: '手续费', param: 'serviceFee', formatter: PriceFormat },
    { title: '结算金额', param: 'settlementAmount', formatter: PriceFormat },
    { title: '订单状态', param: 'orderStatus', formatter: OrderStatusFormat },
    { title: '是否结算', param: 'isSettlement', formatter: SettlementFormat },
    { title: '结算时间', param: 'settlementTime', formatter: DateFormat, overflow: true,width:160 },
    { title: '确认收货时间', param: 'receiveTime', formatter: DateFormat, overflow: true,width:160 },
    { title: '创建时间', param: 'createTime', formatter: DateFormat, overflow: true,width:160 },
    { title: '支付单号', param: 'payOrderNo', overflow: true,width:180 },
    {
      title: '操作',
      width: 240,
      fixed: 'right',
      operation: [
        { title: '查看详情', icon: 'el-icon-document', click: (data) => this.openDialog('OrderDescDialog', {...data,shopName:this.shopNameForam(data.shopId)}) },
        { title: '查看物流', click: this.openExpress, show: this.showOpenExpress },
        { title: '积分发放情况', click: this.openWealthRecord, show: ()=>{return this.user.user.role != 2} },
      ],
    },
  ]

  // 打开物流详情弹窗
  private openExpress(data:any){
    // data. 为行数据
    const t = this.$refs.ExpressDialog as ExpressDialog
    // TODO 传入物流编号
    t.open(data.orderCode)
  }
  // 是否显示 查看物流 按钮
  private showOpenExpress(data:any){
    // data. 为行数据
    // orderStatus 订单状态，可查看后端  枚举 OrderStatus 或前端常量 OrderStatus
    if(data.orderStatus == 4 && data.deliveryType == 0){
      return true;
    }
    return false
  }

  // 打开积分流水
  public openWealthRecord(data:any){
    const d = this.$refs.UserWealthRecordDialog as UserWealthRecordDialog
    d.open({recordNo: data.orderCode,userId: data.userId})
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }

  private batchDisable(){
    return this.selectData.length <= 0
  }

  private pageActiveMenu:any = undefined
  public activated(){
    if (this.$route.query.settlementTime) {
      this.queryParam.settlementTimeDaterange = [this.$route.query.settlementTime + ' 00:00:00',this.$route.query.settlementTime + ' 23:59:59'];
    }else {
      this.queryParam.settlementTimeDaterange = []
    }
    const am = this.$route.query.activeMenu
    if(this.pageActiveMenu != am){
      // 如果路由的菜单不一致则刷新
      this.pageActiveMenu = am
      this.activeMenuSelect(am)
      // this.loadData()
    } else {
      this.loadData()
    }

  }
  public async created() {
    // const am = this.$route.query.activeMenu
    // if(am){
    //   this.activeMenu = am
    // }
    // this.loadData()
    this.loadShop()
  }

  private exportOrderHandle(){
    // 导出
    // if(this.selectData.length <= 0){
    //   return
    // }

    const loading = this.$loading({
          lock: true,
          text: '正在导出订单',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

      const param = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      const orderIds = this.selectData.map(e=>e.id)
      param.orderIds = orderIds

      ExportSettlementOrder(param,"导出结算订单.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  private async batchConfirmOrder(){
    if(this.selectData.length <= 0){
      return
    }
    // 只有筛选已支付的订单
    const hs = this.selectData.filter(e=>e.orderStatus == 2)
    if(hs.length <= 0){
      Message.error('有效数据为0.只有状态为已支付的才能执行确认操作')
      return
    }

    MessageBox.confirm('批量确认执行数据条数为：'+hs.length+"，是否确认", '提示', {
      type: 'warning',
    }).then(async () => {
      const orderCodes = hs.map(e=>e.orderCode)
      const ruslt = await BatchConfirmOrder({ orderCodes })
      if (ruslt) {
        Message.success('批量确认成功')
        this.loadData()
      }
    })

  }

  private async batchDeliveryOrder(){
    if(this.selectData.length <= 0){
      return
    }
    // 只有筛选已确认的订单
    const hs = this.selectData.filter(e=>e.orderStatus == 3)
    if(hs.length <= 0){
      Message.error('有效数据为0.只有状态为已确认的才能执行发货操作')
      return
    }

    MessageBox.confirm('批量发货执行数据条数为：'+hs.length+"，是否确认", '提示', {
      type: 'warning',
    }).then(async () => {
      const orderCodes = hs.map(e=>e.orderCode)
      const ruslt = await BatchDeliveryOrder({ orderCodes })
      if (ruslt) {
        Message.success('批量发货成功')
        this.loadData()
      }
    })
  }

  //。选择菜单
  private activeMenuSelect(e:any){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
    let hideRefundStatus = true
    if(e == 'refund'){
      hideRefundStatus = false
    }
    this.tableHander.forEach(e=>{
        if(e.param == 'refundStatus'){
          e.hide = hideRefundStatus;
        }
      })
  }

  private getRequestParam(){
    const param = { ...this.queryParam }
    if (!this.queryParam.orderStatus) {
      param.orderStatusNot = -1
    }
    if (param.createTimeDaterange.length > 0) {
      param.createTimes = DateFormat(param.createTimeDaterange[0]) + ',' + DateFormat(param.createTimeDaterange[1])
    }
    if (param.settlementTimeDaterange.length > 0) {
      param.settlementTimes = DateFormat(param.settlementTimeDaterange[0]) + ',' + DateFormat(param.settlementTimeDaterange[1])
    }
    if (param.receiveTimeDaterange.length > 0) {
      param.receiveTimes = DateFormat(param.receiveTimeDaterange[0]) + ',' + DateFormat(param.receiveTimeDaterange[1])
    }
    param.startRow = (this.tableCurrntPage - 1) * (param.limit || 12)


    // 根据选择菜单的不同查询不同的数据
    // 已支付
    param.orderStatusIn = [2,3,4,5,6,11,31,32]
    if(this.activeMenu == 'wait'){
      // 待结算
      param.orderStatusIn = [2,3,4,6,11,31]
      param.isSettlement = 0
    }else if(this.activeMenu == 'waitFinish'){
      // 待入帐。 已收货 未结算的订单
      param.orderStatusIn = undefined
      param.orderStatus = 5
      param.isSettlement = 0
    }else if(this.activeMenu == 'finish'){
      // 已结算
      param.isSettlement = 1
    } else if(this.activeMenu == 'refund'){
      // 已退款
      param.orderStatusIn = undefined
      param.orderStatus = 32
    } else if(this.activeMenu == 'error'){
      // 结算异常订单，确认收货时间在今天之前 ，但是还订单 状态是已收货/已完成
      param.orderStatusIn = [5,6]
      param.receiveTimeLt = DateFormat2(new Date())+" 00:00:00"
      param.isSettlement = 0
    }
    return param
  }

  public async loadData() {
    const param = this.getRequestParam()

    const result = await QueryOrderInfoList(param)
    this.tableTotal = result.total
    this.tableData = result.list

    const resCounts = await QuerySettlementOrderCounts(param)
    this.orderCounts = resCounts

  }

  public search() {
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  private selectChange(selection: any) {
    this.selectData = selection
  }

  private openDialog(dia: string, data?: any) {
    const f = this.$refs[dia] as any
    f.open(data)
  }

  private showConfirmOrder(data: any) {
    return data.orderStatus == 2
  }
  private canOperateRefundOrder(data: any) {
    const s = data.orderStatus
    return s === 31 || s === 2 || s === 3 || s === 4 || s === 5 || s === 6
  }
  private showConfirmRefund(data: any) {
    if (this.user.user.role === 2) return false
    return data.refundStatus === 21 && this.canOperateRefundOrder(data)
  }
  private showCancelRefund(data: any) {
    if (this.user.user.role === 2) return false
    return (data.refundStatus === 21 || data.refundStatus === 24) && this.canOperateRefundOrder(data)
  }
  private showDeliveryOrder(data: any) {
    return data.orderStatus == 3
  }
  private showUpdateDeliveryOrder(data: any) {
    return data.deliveryType == 0 &&  data.orderStatus == 4
  }

  private refundOrderHandle(data: any){
    MessageBox.confirm('是否同意退款？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await ConfirmRefund({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('订单已同意退款')
        this.loadData()
      }
    })
  }
  private cancelRefundOrderHandle(data: any){
    MessageBox.confirm('是否取消退款？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await CancelRefund({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('订单已取消退款')
        this.loadData()
      }
    })
  }

  private confirmOrder(data: any) {
    MessageBox.confirm('确定要将该订单变为已确认吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await ConfirmOrder({ orderCode: data.orderCode })
      if (ruslt) {
        Message.success('订单确认成功')
        this.loadData()
      }
    })
  }
  private refusedOrder(data: any) {
    MessageBox.prompt('请输入拒绝理由', '提示', {
      type: 'warning',
    }).then(async (refusedMsg: any) => {
      const ruslt = await RefusedOrder({ orderCode: data.orderCode, refusedMsg: refusedMsg.value })
      if (ruslt) {
        Message.success('订单已拒绝')
        this.loadData()
      }
    })
  }
  private deliveryOrder(data: any) {

    if(data.deliveryType == 0){
      // 快递
      const d = this.$refs.ShippedDialog as ShippedDialog
      d.open(data)
    } else {
      // 自提
      MessageBox.prompt('请输入提货码', '提示', {
        type: 'warning',
      }).then(async (md: any) => {
        const ruslt = await DeliveryOrder({ orderCode: data.orderCode,writeOffCode: md.value })
        if (ruslt) {
          Message.success('订单发货成功')
          this.loadData()
        }
      })
    }

  }
  private updateDeliveryOrder(data: any) {

    if(data.deliveryType == 0){
      // 快递
      const d = this.$refs.UpdateShippedDialog as UpdateShippedDialog
      d.open(data)
    } else {
      this.$message.error("非快递订单，无法更换物流单号")
    }

  }
}
